import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { ListPanel, ZeroState, NewMessageButton } from 'ecs-react-components/dist/index.es';
import QueryString from 'query-string';
import { messages } from './SecureMessages.i18n';
import SecureMessagesFilter from './SecureMessagesFilter';
import ThreadMessages from './ThreadMessages';
import Header from '../../components/Header/Header';
import SecureMessageForm from '../../containers/SecureMessage/SecureMessageForm';
import * as MID from '../../redux/modules/secure-message/secure-message-middleware';
import { careProviderSelected,
  showSecureMessageReplyItem,
  secureMessageThreadSelected,
  secureMessageArchivedThreadSelected,
} from '../../redux/modules/secure-message/actions/creators';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';

class SecureMessages extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    const { language, timeZone, timeZoneOffset, location, patientId, dispatch } = this.props;

    const parsedQueryString = QueryString.parse(location.search);
    if (parsedQueryString.isAutoRedirect && parsedQueryString.threadId) {
      const threadId = parseInt(parsedQueryString.threadId, 10);
      dispatch(MID.threadMessagesRequested(
        patientId,
        parseInt(parsedQueryString.threadId, 10),
        language,
        timeZone,
        timeZoneOffset)).then(
        (responses) => {
          dispatch(MID.patchReviewedThreadMessages(
            patientId,
            threadId,
            responses.data,
            language,
            timeZone,
            timeZoneOffset));
        }
      );
      this.props.dispatch(secureMessageThreadSelected(threadId));
    }
  }

  onNewMessageButtonClick = () => {
    this.props.dispatch(careProviderSelected(null));
    this.setState({ showModal: true });
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  handleListItemClick = (index) => {
    const {
      language,
      timeZone,
      timeZoneOffset,
      filteredThreads,
      filter,
      patientId,
      dispatch,
    } = this.props;

    if (filter === 'Current') {
      dispatch(secureMessageThreadSelected(filteredThreads[index].itemId));
    } else {
      dispatch(secureMessageArchivedThreadSelected(filteredThreads[index].itemId));
    }
    this.props.dispatch(MID.threadMessagesRequested(
      patientId,
      filteredThreads[index].itemId,
      language,
      timeZone,
      timeZoneOffset)).then(
      (responses) => {
        dispatch(MID.patchReviewedThreadMessages(
          patientId,
          filteredThreads[index].itemId,
          responses.data,
          language,
          timeZone,
          timeZoneOffset));
      }
    );

    this.props.dispatch(showSecureMessageReplyItem(false));
    this.props.dispatch(MsgBarActions.dismissMessage());
  }

  closeModal = () => {
    this.setState({ showModal: !this.state.showModal });
  }

  renderThreadsContentPane() {
    const { filteredThreads, filter } = this.props;

    if (filteredThreads && filteredThreads.length > 0) {
      return (
          <ListPanel
            items={filteredThreads}
            title={messages.listPanel.title}
            handleListItemClick={this.handleListItemClick}
            selectedIndex={
              filter === 'Current' ?
                this.props.selectedThreadIndex :
                this.props.selectedArchivedThreadIndex
            }
            qaTag="ThreadsContainer"
          />
      );
    }

    return (<ZeroState
      zeroStateMessage={ <FormattedMessage { ...messages.page.zeroStateMessage } /> }
      stateIconCss="fa fa-envelope-o"
    />);
  }

  renderMessagesContentPane() {
    if (this.props.filteredThreads && this.props.filteredThreads.length > 0) {
      return (
          <ThreadMessages
            messages={ this.props.messages }
          />
      );
    }
    return null;
  }

  render() {
    return (
      <div id="content">
        <Header headerTitle={<FormattedMessage { ...messages.page.title } /> }
          badgeNumber={this.props.unreadCount}
        />
        <div className="spacer tiny"></div>
        <div className="spacer small"></div>
        <LoadingIndicatorContainer loadingKey="SecureMessages" >
          <div className="row clearfix">
            <div className="col-xs-12">
              <div className="row">
                <SecureMessagesFilter />
                <div className="col-xs-2 pull-right">
                  <NewMessageButton
                    onClick={ this.onNewMessageButtonClick }
                    buttonName={ messages.link.newMessage }
                    buttonClassName="visible-md-inline visible-lg-inline float-right"
                  />
                </div>
                <div className="spacer small" />
                  <SecureMessageForm
                    showModal={ this.state.showModal }
                    close={ this.closeModal }
                    initiatedfromMessagesModule
                  />
              </div>
            </div>
            <div className="col-xs-12">
              { this.renderThreadsContentPane() }
              { this.renderMessagesContentPane() }
            </div>
          </div>
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

SecureMessages.propTypes = {
  dispatch: PropTypes.func,
  patientId: PropTypes.number.isRequired,
  threads: PropTypes.array,
  messages: PropTypes.array,
  timeZone: PropTypes.string,
  timeZoneOffset: PropTypes.string,
  language: PropTypes.string,
  location: PropTypes.object,
  selectedThreadIndex: PropTypes.number,
  selectedArchivedThreadIndex: PropTypes.number,
  filteredThreads: PropTypes.array,
  filter: PropTypes.string,
  unreadCount: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => ({
  patientId: state.profile.patient.patientId,
  messages: state.secureMessage.messages,
  timeZone: state.facility.timeZoneAbbreviation,
  timeZoneOffset: state.facility.timeZoneOffset,
  language: state.language.languageCode,
  location: ownProps.location,
  threads: state.secureMessage.threads,
  selectedThreadIndex: state.secureMessage.selectedThreadIndex,
  selectedArchivedThreadIndex: state.secureMessage.selectedArchivedThreadIndex,
  filter: state.secureMessage.filter,
  unreadCount: state.secureMessage.unreadCount,
});

export default connect(mapStateToProps)(SecureMessages);